import type { SITE_WORKING_CONDITION_ACQUISITION_SENSORS_TABLE_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-working-condition-acquisition-sensors-table/site-working-condition-acquisition-sensors-table.fr.ts";

export const SITE_WORKING_CONDITION_ACQUISITION_SENSORS_TABLE_ENGLISH_LOCALE = {
  headers: {
    hwId: "Sensor Hw Id",
    csId: "Sensor Cs Id",
    name: "Room name",
    serialNumber: "Serial number",
    installationDate: "Installation date",
    lastTemperatureDate: "Last temperature point",
  },
  empty: "No sensor",
} satisfies typeof SITE_WORKING_CONDITION_ACQUISITION_SENSORS_TABLE_FRENCH_LOCALE;
